import { call, put, select } from "redux-saga/effects"
import { updatePixelFiredAtFailed, updatePixelFiredAtSuccess } from "../actions"
import { backervoiceApi } from "../apis"
import { getProjectsBackerUUID } from "../reducers/projects"

export default function* handleReportPixelFired() {
  try {
    const backerUUID = yield select(getProjectsBackerUUID)

    const data = yield call(backervoiceApi.updatePixelFiredAt, backerUUID)

    yield put(updatePixelFiredAtSuccess(data))
  } catch (e) {
    yield put(updatePixelFiredAtFailed(e))
  }
}
